<template>
  <section
      id="donate-blood-section"
      class="section-scc-portal container"
  >
    <message-banner :variant="messages.variant"  :showBanner="messages.showMessage" :message="messages.message" />
    <p class="p-section">Send activation code:</p>
    <form id="form-activate-portal-scc" >
      <div id="container-radio-box-activate-page">
        <div
            class="form-check form-check-inline"
            v-if="this.createNewAccountData.phoneMobile !== ''
              && !this.createNewAccountData.smsOptedOut
              && this.sendSms.smsEnable"
        >
          <input
              class="form-check-input"
              type="radio"
              id="check-box-by-phone"
              value="phone"
              v-model="dataActivationCode"
          >
          <label class="form-check-label" for="check-box-by-phone">By phone: {{ this.createNewAccountData.phoneMobile }}</label>
        </div>
        <div class="form-check form-check-inline">
          <input
              class="form-check-input"
              type="radio"
              id="check-box-by-email"
              value="email"
              v-model="dataActivationCode"
          >
          <label class="form-check-label" for="check-box-by-email">By email: {{ this.createNewAccountData.email }}</label>
        </div>
      </div>
      <p></p>

      <div class="row container-item-form " style= "margin-top: 50px">
        <button
            type="button"
            class="button-section btn"
            value="send"
            v-on:click="actionRequestActivationCode"
        >
          SEND
          <font-awesome-icon :icon="['fas', 'chevron-right']" />
        </button>
      </div>
    </form>
  </section>
</template>

<script>
/*
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight,  } from '@fortawesome/free-solid-svg-icons'
 */
import { mapState } from 'vuex';
import messageBanner from "../../../elements/messageBanner";
import xlooLib from "@/librarys/xlooLib";
//library.add( faChevronRight )
export default {
  name: "cnaRequestActivationCode",
  components: { messageBanner },
  data(){
    return {
      dataActivationCode: '',
      messages:{
        showMessage: false,
        messageFailSendEmail: false,
        variant: 'danger',
        message: '',
      },
    }
  },
  computed : {
    ...mapState({
      createNewAccountData: state => state.auth.createNewAccountData,
      sendSms: state => state.settingsAndCustomize.crmSettings.sendSms,
    })
  },
  mounted() {
    this.seenSms = this.createNewAccountData.smsOptedOut
  },
  methods:{
    async actionRequestActivationCode(){
      let dataReq = {}
      dataReq = {
        typeActions: 'request',
        idDonor: this.$store.getters["auth/createNewAccountData"].idDonor,
      }
      switch (this.dataActivationCode){
        case '':
          this.errorAlert('Choose a method to send the activation code' );
          return
        case 'phone':
          dataReq.sendingType = 'phone'
          dataReq.phone_to = "+1" + xlooLib.phoneCleaner(this.createNewAccountData.phoneMobile)
          dataReq.phone_from = this.sendSms.smsNumber
          break
        case 'email':
          dataReq.sendingType = 'email'
          dataReq.email_account = this.$store.getters["communication/emailSettings"].emailUserId
          dataReq.sendTo = this.createNewAccountData.email
      }
      this.$root.$emit("showSpinner")
      const response = await this.$store.dispatch('auth/SET_activationCodeRequest', dataReq)
      this.$root.$emit("hideSpinner")

      if (!response.result.result){
        this.messages.message = 'An error occurred while sending the letter. Try again or contact your administrator.'
        this.messages.showMessage = true
        this.messages.variant = 'danger'
      } else {
        this.messages.message = 'Activation code has been sent.'
        this.messages.showMessage = true
        this.messages.variant = 'success'
        this.$store.commit('auth/set_showPage', { triggerRequestActivationCode: true})
        await this.$router.push( { name: 'cnaEnterActivationCode' } )
      }
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
  }
}
</script>

<style scoped>
#container-radio-box-activate-page{
  display: flex;
}
</style>
